import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item"];
import React from 'react';
import { formatDate } from '../../utils';
import { Highlight } from '../Highlight/Highlight';
import { DescDelimiter } from './DescDelimiter';
import { Row } from './Row';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MLRow(_ref) {
  var item = _ref.item,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Highlight, {
      text: item.maillist
    }), /*#__PURE__*/_jsx(DescDelimiter, {}), /*#__PURE__*/_jsx("time", {
      children: formatDate(item.time * 1000)
    })]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    description: description,
    item: item
  }, otherProps));
}
// #sourceMappingURL=MLRow.js.map